import { render } from "./EditPerson.vue?vue&type=template&id=e20b1ef6"
import script from "./EditPerson.vue?vue&type=script&lang=js"
export * from "./EditPerson.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__